module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 011.b7db1ece.jpg";